/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import { useEffect, useState } from 'react';
import { accountService } from '../services/accountService';

/**
 * Branding of an account ({ theme, logoUrl, faviconUrl }), used by the sub-account
 * pages to show what empty sub-account branding fields fall back to.
 * Null while loading, when no account is given, or when it can't be loaded.
 */
export function useAccountBranding(accountId) {
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!accountId) {
      setBranding(null);
      return undefined;
    }
    let cancelled = false;
    accountService.getAccountById(accountId)
      .then(({ data }) => {
        if (cancelled) return;
        setBranding({
          theme: data.theme || null,
          logoUrl: data.logoUrl || null,
          faviconUrl: data.faviconUrl || null,
        });
      })
      .catch(() => {
        if (!cancelled) setBranding(null);
      });
    return () => { cancelled = true; };
  }, [accountId]);

  return branding;
}
